<div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">Readings &amp; Dosages</h5>

    <button *ngIf="!isUnassigned" class="btn btn-sm btn-outline-primary" (click)="openDialog()">
        <i class="bi bi-plus-lg"></i> Add Readings &amp; Dosages
    </button>
</div>

<div *ngIf="isUnassigned" class="text-muted small mb-2">
    Taken before this customer had assets, or on an asset that has since been deleted.
</div>

<div class="row" style="max-height: calc(100vh - 400px); overflow-y: auto;">
    <!-- Readings -->
    <div class="col-12 col-xl-6 mb-3">
        <h6 class="text-primary border-bottom pb-2">Readings History</h6>
        <div *ngIf="isLoading" class="text-muted">Loading...</div>
        <div *ngIf="!isLoading && readings.length === 0" class="text-muted">No readings recorded.</div>
        <div *ngFor="let reading of readings" class="card mb-2">
            <div class="card-header py-1">{{reading.maintenanceReadingDate | date:'medium'}}</div>
            <div class="card-body p-2">
                <table class="table table-sm mb-0">
                    <tbody>
                        <tr *ngFor="let v of reading.maintenanceReadingValues">
                            <td>{{v.itemName}}</td>
                            <td class="text-end">{{v.itemValue}}</td>
                        </tr>
                        <tr *ngIf="!reading.maintenanceReadingValues || reading.maintenanceReadingValues.length === 0">
                            <td class="text-muted">No values</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Dosages -->
    <div class="col-12 col-xl-6 mb-3">
        <h6 class="text-primary border-bottom pb-2">Dosages History</h6>
        <div *ngIf="isLoading" class="text-muted">Loading...</div>
        <div *ngIf="!isLoading && dosages.length === 0" class="text-muted">No dosages recorded.</div>
        <div *ngFor="let dosage of dosages" class="card mb-2">
            <div class="card-header py-1">{{dosage.dosageDate | date:'medium'}}</div>
            <div class="card-body p-2">
                <table class="table table-sm mb-0">
                    <tbody>
                        <tr *ngFor="let v of dosage.dosageValues">
                            <td>{{v.description}}</td>
                            <td class="text-end">{{v.value}} {{v.uom}}</td>
                            <td class="text-center" style="width: 80px;">
                                <span *ngIf="v.addToInvoice" class="badge bg-success">Invoice</span>
                            </td>
                        </tr>
                        <tr *ngIf="!dosage.dosageValues || dosage.dosageValues.length === 0">
                            <td class="text-muted">No values</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<readings-and-dosages-dialog #readingsAndDosagesDialogRef (onSaved)="refresh()"></readings-and-dosages-dialog>
